// extracted by mini-css-extract-plugin
module.exports = {"body_cont":"PrivacyPolicy_body_cont__1NDDR","heading":"PrivacyPolicy_heading__2FyoU"};